
export default (factor: number) => {
  const baseValue = 1
  const unit = 'rem'
  return baseValue * factor + unit
}